import React from 'react';
import noop from 'lodash/noop';

import { Button } from '@flowio/react-button';
import { Box } from '@flowio/react-box';
import {
  Worksheet, WorksheetHeader, WorksheetTitle, WorksheetBody,
} from '@flowio/react-worksheet';

import EditRuleWorksheetForm from '../../containers/EditRuleWorksheetForm';
import * as styles from '../features.styles';

import { EditRuleWorksheetProps } from '../../types/components';

const EditRuleWorksheet: React.FC<EditRuleWorksheetProps> = ({
  availableFilters,
  initialValues,
  isSaveDisabled,
  open,
  onCancel,
  onSave,
}) => (
  <Worksheet open={open}>
    <WorksheetHeader>
      <Box alignItems="center" justifyContent="between" className={styles.dialogHeader}>
        <Button
          type="button"
          onClick={onCancel}
          content="Cancel"
        />
        <WorksheetTitle content="Edit Rule" />
        <Button
          type="button"
          intent="primary"
          disabled={isSaveDisabled}
          onClick={onSave}
          content="Save"
        />
      </Box>
    </WorksheetHeader>
    <WorksheetBody>
      <EditRuleWorksheetForm
        initialValues={initialValues}
        availableFilters={availableFilters}
      />
    </WorksheetBody>
  </Worksheet>
);

EditRuleWorksheet.displayName = 'EditRuleWorksheet';

EditRuleWorksheet.defaultProps = {
  availableFilters: [],
  initialValues: undefined,
  open: false,
  onCancel: noop,
  onSave: noop,
};

export default EditRuleWorksheet;
